import AICampusFooter from "@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue";
import SupportContact from "@/components/probaworkflows_base_components/SupportContact/SupportContact.vue";
import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import { get_headers } from "@/utils/constants/constants.js";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import CompanyProgrammesResponsiveList from "./CompanyProgrammesResponsiveList.vue";
import companyManagementPageMixin from "./company_management_page_mixin";
import companyManagementImportConfigurationMixin from "./company_management_import_configuration_mixin";
import companyManagementProjectCreationMixin from "./company_management_project_creation_mixin";
import companyManagementSubProgramMixin from "./company_management_sub_program_mixin";
import companyManagementUserAssignmentMixin from "./company_management_user_assignment_mixin";

export default {
  name: "CompanyManagement",
  mixins: [
    alert_mixin,
    formatting_mixins,
    companyManagementPageMixin,
    companyManagementImportConfigurationMixin,
    companyManagementProjectCreationMixin,
    companyManagementSubProgramMixin,
    companyManagementUserAssignmentMixin,
  ],
  components: {
    navbar,
    GlobalTable,
    AICampusFooter,
    SupportContact,
    CompanyProgrammesResponsiveList,
  },
  data: () => ({
    headers: get_headers(),
    company_types: [],
    company_list: [],
    table_headers: [],
    company_name: "",
    table_safe_company_list: [],
    selected_company_type: "",
    company_description: "",
    project_id: "",
    company_count: 0,
    is_loading: false,
    role: sessionStorage.getItem("user_role") || null,
    sidebar_components: [],
    sorted_sidebar_components: [],
    users: [],
    users_list: [],
    user_table_headers: [],
    assigned_users: [],
    deactivated_projects: [],
    update_company_name: "",
    update_company_description: "",
    update_selected_company_type: [],
    hostname: "",
    hero_title: "",
    hero_description: "",
    is_super_user: false,
    sub_programs: {},
    expanded_programs: {},
    create_sp_name: "",
    create_sp_description: "",
    create_sp_project_id: null,
    edit_sp_id: null,
    edit_sp_name: "",
    edit_sp_description: "",
    edit_sp_project_id: null,
    search_query: "",
    items_per_page: 10,
    current_page: 1,
    active_config_project: sessionStorage.getItem("project_id") || null,
    config_table_data: [],
    import_source_project_id: "",
    import_preview: null,
    import_form_ids: [],
    import_template_ids: [],
    import_preview_loading: false,
  }),
  mounted() {
    this.load_data();
    this.get_deactivated_projects();
    this.hostname = window.location.hostname || "";
    this.set_domain_content();
  },
};
